export default "__VITE_ASSET__6aee1702__"